<div class="container-fluid">
  <div class="header-container flex">
    <div class="page-header">
      <span class="fa fa-cube"></span>{{ "bikeshop.menu.cyclists" | translate }}
    </div>
    <a [routerLink]="['../customers-import']" style="margin-left:auto;width: 200px;">
      <button pButton class="full-width" label="{{ 'bikeshop.cyclist.import_csv' | translate }}"></button>
    </a>
  </div>
  <div class="content">
    <div class="row">
      <div class="col-md-12 flex" style="font-size: 24px">
        <div style="margin-left: auto!important;">
          <div *ngIf="canSyncCustomers" pTooltip="{{ 'bikeshop.cyclists.refresh_note' | translate }}"
               tooltipPosition="left" class="hubtiger-sync pull-right"
               [ngClass]="{ 'fa-spin': syncing }" style="margin-right: 16px!important;"
               (click)="refreshPOSCustomers()">
          </div>
        </div>
        <!--<div pTooltip="{{ 'bikeshop.cyclist.add_cyclist' | translate }}" style="margin-right:10px;"
             tooltipPosition="left" class="hubtiger-add pull-right" (click)="addNewCyclist()"></div>-->
        <hub-button [icon]="'plus-alt'" [size]="'md'"
                    [style]="'outline'"
                    [text]="('bikeshop.cyclist.add_cyclist') | translate"
                    (buttonClick)="addNewCyclist()"></hub-button>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-12">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon" style="position: relative !important;"><i class="fa hubtiger-search" (click)="searchCyclist()"></i></span>
          <input type="text" pInputText [(ngModel)]="search" placeholder="{{
              'bikeshop.cyclist.search_placeholder' | translate
            }}" (keyup.enter)="searchCyclist()" />
          <span class="p-inputgroup-addon"><i class="fa fa-times" (click)="clearSearch()"></i></span>
        </div>
      </div>
    </div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
    <!--<div class="row margin-top-16">
    <div pTooltip="Create a new cyclist" tooltipPosition="left" class="fa fa-user-plus font-button pull-right"
      style="margin-left: auto!important;margin-right: 16px!important;" (click)="addUser()"></div>
  </div>-->
    <div class="margin-top-16">
      <p-table #cyclistsTable [columns]="columns" [value]="cyclists" *ngIf="cyclists.length > 0">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              {{ col.header }}
            </th>
            <th style="width: 80px;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user let-columns="columns">
          <tr [pSelectableRow]="user">
            <td *ngFor="let col of columns">
              <div *ngIf="col.type !== 'action'">
                {{
                                col.type === "boolean"
                                    ? user[col.field]
                                        ? ("general.yes" | translate)
                                        : ("general.no" | translate)
                                    : col.type === "Role"
                                        ? user[col.field] === "Admin"
                                            ? ("bikeshop.cyclist.userrole.admin" | translate)
                                            : user[col.field] === "Super User"
                                                ? ("bikeshop.cyclist.userrole.superuser" | translate)
                                                : ("bikeshop.cyclist.userrole.cyclist" | translate)
                                        : user[col.field]
                }}
              </div>
            </td>
            <td style="text-align:left;">
              <div pTooltip="{{ 'bikeshop.cyclist.edit_user' | translate }}" tooltipPosition="left"
                   *ngIf="user.Email || user.PhoneNumber" class="fa hubtiger-edit font-button"
                   (click)="editUser(user)">
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-paginator #paginator [rows]="limit" [totalRecords]="totalRecords" *ngIf="cyclists.length > 0"
                   (onPageChange)="paginate($event)"></p-paginator>
    </div>
    <div *ngIf="cyclists.length > 0">
      <small>
        {{ "bikeshop.cyclist.note" | translate }}
      </small>
    </div>

    <div *ngIf="loading">
      <div style="height: 50px"></div>
    </div>


    <div class="empty-state-container" *ngIf="cyclists.length == 0 && !searched && !loading">
      <img src="../../../../../assets/images/no_customers.png" alt="Empty State" class="empty-state-image">
      <div class="empty-state-header-text">{{ "bikeshop.cyclist.start_searching" | translate }} </div>
      <div class="empty-state-header-text">{{ "bikeshop.cyclist.start_searching_details" | translate }}</div>

    </div>

    <div class="empty-state-content" *ngIf="cyclists.length == 0 && searched && !loading">
      <div>
        <span class="fa fa-search fa-3x"></span>
      </div>
      <div>
        <div class="empty-state-text">
          <!--<div class="empty-state-header-text">Start searching for a customer </div>
        <div class="empty-state-header-text">All matching customers will be displayed here after searching</div>-->

          <div class="empty-state-header-text">{{ "bikeshop.cyclist.no_customers_found" | translate }} {{searchedInfo}} </div>
          <div class="empty-state-header-text">{{ "bikeshop.cyclist.search_something_else" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
